import * as React from "react"
const Sports = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M22.037 4.009c-9.895 0-17.916 8.021-17.916 17.916 0 9.896 8.02 17.917 17.916 17.917s17.917-8.021 17.917-17.917c0-9.895-8.021-17.916-17.917-17.916Zm-3.45 3.081a15.276 15.276 0 0 1 6.901 0l-3.447 2.066-3.454-2.066Zm-3.28 1.17 5.39 3.225v3.93l-5 3.633-3.663-1.267-1.051-6.331a15.276 15.276 0 0 1 4.325-3.19Zm-6.546 6.203.641 3.865-2.558 2.558a15.138 15.138 0 0 1 1.917-6.423Zm-1.734 10.04 4.169-4.169 3.655 1.264 1.937 5.971-1.738 2.822-5.9-.348a15.133 15.133 0 0 1-2.123-5.54Zm4.425 8.368 3.411.2 1.21 2.87a15.238 15.238 0 0 1-4.62-3.07Zm7.953 4.056-2.121-5.033 1.725-2.807h6.042l1.634 2.832-1.863 4.981c-1.79.33-3.624.34-5.417.027Zm8.654-1.009 1.016-2.718 2.992.188a15.23 15.23 0 0 1-4.01 2.53h.002Zm6.328-5.077-5.418-.34-1.68-2.91 1.947-5.994 3.607-1.247 4.142 4.515a15.155 15.155 0 0 1-2.598 5.976Zm2.863-9.66-2.58-2.812.649-3.902a15.14 15.14 0 0 1 1.931 6.715Zm-4.153-9.728-1.055 6.332-3.655 1.263-5-3.634v-3.93l5.378-3.226c1.622.801 3.089 1.882 4.332 3.195ZM17.501 21.06l4.542-3.3 4.541 3.3-1.734 5.34h-5.615l-1.734-5.34Z"
    />
  </svg>
)
export default Sports